import axios from "axios";
import router from "../../router";
import Qs from "qs";
import blake2b from "blake2b";
import md5 from "md5";
import { getSecretInfo, clearSecret } from "./secretManager";

function generateUnique32CharId() {
  const timestampPart = Date.now().toString(36);
  const randomPart = Array.from({ length: 32 - timestampPart.length }, () =>
    (Math.random() * 36 | 0).toString(36)
  ).join("");
  return timestampPart + randomPart;
}

//设置拦截
// 发起普通请求，不验证token
let baseRequest = axios.create({});

// 带token的请求，可能导致跨域
let authRequest = axios.create({});

// authRequest请求拦截器
authRequest.interceptors.request.use(
  config => {
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

// authRequest响应拦截器
authRequest.interceptors.response.use(
  function(response) {
    return responseReturn(response);
  },
  error => {
    return Promise.reject(error);
  }
);

// baseRequest响应拦截器
baseRequest.interceptors.response.use(
  function(response) {
    return responseReturn(response);
  },
  error => {
    return Promise.reject(error);
  }
);

// 处理返回
function responseReturn(response) {
  let res = response.data;

  // ★ 临时密钥过期（1005）：清缓存 + 用原始参数重试一次
  if (res.code == "1005") {
    clearSecret();
    const config = response.config || {};
    const originalObj = config._originalObj;
    const retryCount = config._retryCount || 0;
    // 只重试一次，避免死循环
    if (originalObj && retryCount < 1) {
      return sendHttp(
        Object.assign({}, originalObj, { _retryCount: retryCount + 1 })
      );
    }
    return res;
  }

  if (res.code == "0") {
    return res;
  } else {
    console.log(res.msg);
    return res;
  }
}

//封装请求
export async function sendHttp(obj) {
  let {
    url,
    method = "get",
    data = null,
    auth = true,
    stringify = true,
    _retryCount = 0
  } = obj;

  // ★ 备份原始参数，1005 重试要用（不污染调用方传进来的对象）
  const originalData = data ? Object.assign({}, data) : null;

  // ★ 先拿 secret（首次触发 getsecret，之后走缓存；并发去重）
  let plainSecret = "";
  let encryptedSecret = "";
  try {
    const info = await getSecretInfo();
    plainSecret = info.plain;
    encryptedSecret = info.encrypted;
  } catch (e) {
    console.error("[secret] 获取失败", e);
    // 业务强依赖时改为 throw e
  }

  // ★ 用副本组装参数，避免修改原始 data
  const reqData = data ? Object.assign({}, data) : {};

  // 时间戳 / token / 公共参数（保持原逻辑）
  let timestamp = new Date().getTime();
  let token = window.localStorage.getItem("token");
  if (token) {
    reqData.token = token;
  }
  reqData.app_id = "867520190510168";
  reqData.timestamp = timestamp;
  reqData.from = "app";
  reqData.nonce_str = generateUnique32CharId();

  // ★ 所有接口加 secret（RSA 密文）
  if (encryptedSecret) {
    reqData.secret = encryptedSecret;
  }

  // ★ 生成签名：app_secret 用临时密钥明文
  let arr = [];
  for (let i in reqData) {
    if (i !== "sign" && i !== "file") {
      arr.push(i + ":" + reqData[i]);
    }
  }
  const signStr = arr.sort().join("#");
  const hash = blake2b(32)
    .update(Buffer.from(signStr + (plainSecret || "")))
    .digest("hex");
  reqData.sign = hash;

  // 序列化
  let datas;
  if (method === "get") {
    datas = Qs.stringify(reqData);
  } else {
    datas = stringify ? Qs.stringify(reqData) : reqData;
  }

  // ★ 挂原始参数和重试计数，供 1005 时重试
  const config = { url, method, data: datas };
  config._originalObj = { url, method, data: originalData, auth, stringify };
  config._retryCount = _retryCount;

  return new Promise((resolve, reject) => {
    const req = auth ? authRequest : baseRequest;
    req(config)
      .then(res => resolve(res))
      .catch(error => reject(error));
  });
}


// WEBPACK FOOTER //
// ./src/assets/js/request.js